import { Link } from 'react-router-dom';
export default function ServicesMenu(){
    return(
        <>
        <h6 className="widget-title text-white pb-15 mb-35">Our Services</h6>
        <ul className="fot-list">
            <li><Link to="/contact">IT Support</Link></li>
            <li><Link to="/services">IT Consultancy</Link></li>
            <li><Link to="/services">Cloud Computing</Link></li>
            <li><Link to="/services">Cyber Security</Link></li>
            <li><Link to="/contact">Custom Software</Link></li>
        </ul>
        </>
        
    )
}